import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

// import echarts from 'echarts'
// Vue.prototype.$echarts = echarts

// 引入 ECharts 主模块
// var echarts = require('echarts/lib/echarts');
import echarts from 'echarts/lib/echarts'
// 引入柱状图
require('echarts/lib/chart/bar');
// 引入折线图
require("echarts/lib/chart/line");
// 引入提示框和标题组件
require('echarts/lib/component/tooltip');
require('echarts/lib/component/title');

Vue.prototype.$echarts = echarts

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import enLocale from 'element-ui/lib/locale/lang/en'
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'

import en from "./store/lang/en.js"
import zh from "./store/lang/zh.js"
import VueI18n from 'vue-i18n'
Vue.use(VueI18n)
const i18n = new VueI18n({
  locale: 'en-US',    // 语言标识
  //this.$i18n.locale // 通过切换locale的值来实现语言切换
  messages: {
    'zh-CN': {...zh,...zhLocale},   // 中文语言包
    'en-US': {...en,...enLocale}    // 英文语言包
  }
})
Vue.use(ElementUI, {
    i18n: (key, value) => i18n.t(key, value)
})

Vue.config.productionTip = false;

new Vue({
	router,
	store,
  i18n,
	render: h => h(App)
}).$mount("#app");
